import { FlexColumn } from '@gorila-shared-ui/components';
import { LabelSmall } from 'baseui/typography';
import moment from 'moment';
import { useRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { deliveryDateState } from '../../../storage/reports';
import LocalizedDatePicker from '../../shared/LocalizedDatePicker';

function DeliveryReportFilters() {
  const [selectedDate, setSelectedDate] = useRecoilState(deliveryDateState);
  const { theme, css } = useStyles();

  return (
    <FlexColumn
      gap={theme.sizing.scale200}
      classNames={css({ width: '100%' })}
    >
      <LabelSmall>Fecha:</LabelSmall>
      <LocalizedDatePicker
        value={[selectedDate]}
        onChange={({ date }) => {
          if (date && !Array.isArray(date)) {
            setSelectedDate(date);
          }
        }}
        onClose={() => {
          setSelectedDate(selectedDate);
        }}
        size="compact"
        maxDate={moment().subtract(1, 'day').toDate()}
        formatString="dd MMMM yyyy"
      />
    </FlexColumn>
  );
}

export default DeliveryReportFilters;
